import React, { Fragment } from 'react';

import { CustomLink } from '../../components';

const BASE_LINK = 'https://www.disneyadvertising.com';
const SITES_LINK = 'https://sites.disney.com';

export const REPRESENTATIVE_TEXT =
  "I represent and warrant that I have the authority to create a user account under the above-listed business's account and to use the Disney Ad Sales Portal on behalf of such business.";

export const AGREEMENT_TEXT = (
  <Fragment key="agreement">
    I have read and agree to the{' '}
    <CustomLink
      link={`${BASE_LINK}/disney-client-reporting-portal-terms/`}
      text={'Disney Client Reporting Portal Terms'}
    />
    , <CustomLink link={`${BASE_LINK}/disney-campaign-manager-terms/`} text={'Disney Campaign Manager Terms'} />, and{' '}
    <CustomLink link={`${SITES_LINK}/ngr-privacy-policy/`} text={'Privacy Policy'} />.
  </Fragment>
);
